import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { ColumnDefinitionService } from '../../../rent/service/data/column-definition.service';
import { MeterMediaTypeSelection } from '../../model/const/enums';
import { MeterModel } from '../../model/meter-model';
import { MeterModelService } from '../../service/meter-type.service';
import { MeterModelCommandHandlerResolver } from '../../service/command/meter-model-command-handler-resolver';

@Component({
    selector: 'app-imd-metermodel-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImdMeterModelManagerComponent extends PagedObjectManagerComponent<MeterModel> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private _dataService: MeterModelService,
    dispatcher: CommandDispatcher,
    handlerResolver: MeterModelCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = columnDefinitionService.getImdMeterModelColumnDefinition(this);
    this.title = 'CONSUMPTION.METER_MODEL.METER_MODELS';
    this.preferencesKey = 'consumption.meter-model.list';
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        let meterTypeSelection = MeterMediaTypeSelection.map(v => {
          return { caption: v.name, value: v.value };
        });
        meterTypeSelection.splice(0, 0, { caption: 'ALL_TEXT', value: null });
        this.filterDefinition = [
          new FilterDefinitionItem(
            'CONSUMPTION.METER_MODEL.METER_MODEL',
            'name',
            definition.name,
            null,
            definition.selectedFields.includes('name')
          ),
          new FilterDefinitionItem(
            'CONSUMPTION.MEDIA_TYPE.TYPE',
            'meterType',
            definition.meterType,
            meterTypeSelection,
            definition.selectedFields.includes('meterType')
          ),
          new FilterDefinitionItem(
            'CONSUMPTION.METER_MODEL.MANUFACTURER',
            'manufacturer',
            definition.manufacturer,
            null,
            definition.selectedFields.includes('manufacturer')
          ),
        ];
      })
    );

    this.addEditDeleteCommands();
  }
}
